module.exports = __webpack_public_path__ + "media/app/assets/images/micro-sd-card-thumb-0c4e4df51c54795ed0f006daa0b4cc8b.jpg";